import type { AnalyticsProvider } from '.'
import { isOnServer } from '@/utils/ssr'
import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'

const SentryAnalytics: AnalyticsProvider = {
  isActive: false,
  init() {
    if (isOnServer) return
    const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string
    const sentryEnv = import.meta.env.VITE_SENTRY_ENVIRONMENT as string
    if (!sentryDsn || !sentryEnv) return
    this.isActive = true

    Sentry.init({
      dsn: sentryDsn,
      integrations: [new BrowserTracing()],
      environment: sentryEnv,

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
  },

  track() {
    return
  },
  page() {
    return
  },
  alias() {},
  reset() {},
  error(error: Error | any, additionData?: any) {
    if (!this.isActive) return

    if (!(error instanceof Error)) {
      error = new Error(error?.message || JSON.stringify(error))
    }

    Sentry.captureException(error, additionData)
  },
}

export default SentryAnalytics
